/* __next_internal_client_entry_do_not_use__ Toggle,ToggleIndicator auto */ import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";
import { Spacer } from "../spacing";
import { themeOrDefault } from "../Theme";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "../utils/highVisSlateComponent";
/**
 * @trackcomponent
 */ export var Toggle = function(_param) {
    var id = _param.id, value = _param.value, onChange = _param.onChange, toggleTextToTheLeft = _param.toggleTextToTheLeft, hideText = _param.hideText, disabled = _param.disabled, rest = _object_without_properties(_param, [
        "id",
        "value",
        "onChange",
        "toggleTextToTheLeft",
        "hideText",
        "disabled"
    ]);
    var handleClicked = function() {
        if (disabled) {
            return;
        }
        onChange(!value);
    };
    return /*#__PURE__*/ _jsxs(Container, {
        id: id,
        $reverseDirection: !!toggleTextToTheLeft,
        onClick: handleClicked,
        disabled: disabled,
        role: "switch",
        "aria-checked": value ? "true" : "false",
        "aria-labelledby": rest["aria-labelledby"],
        "aria-describedby": rest["aria-describedby"],
        "data-test-id": rest["data-test-id"],
        type: "button",
        children: [
            /*#__PURE__*/ _jsx(ToggleWrapper, {
                $isOn: value,
                $disabled: disabled,
                theme: rest.theme,
                children: /*#__PURE__*/ _jsx(ToggleIndicator, {
                    $isOn: value,
                    $disabled: disabled,
                    theme: rest.theme
                })
            }),
            hideText ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 8
                    }),
                    /*#__PURE__*/ _jsx(StyledTypography, {
                        $isOn: value,
                        $disabled: disabled,
                        children: value ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "aNyx9i",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "On"
                                }
                            ]
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "kQTTtA",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Off"
                                }
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var getBorderFromTheme = function(isOn, disabled, theme) {
    var toggle = themeOrDefault(theme).toggle;
    return toggle[disabled ? "disabled" : "active"][isOn ? "on" : "off"].toggle.container.border;
};
var getContainerFillFromTheme = function(isOn, disabled, theme) {
    var toggle = themeOrDefault(theme).toggle;
    return toggle[disabled ? "disabled" : "active"][isOn ? "on" : "off"].toggle.container.surface;
};
var getIndicatorFillFromTheme = function(isOn, disabled, theme) {
    var toggle = themeOrDefault(theme).toggle;
    return toggle[disabled ? "disabled" : "active"][isOn ? "on" : "off"].toggle.indicator.surface;
};
var getColorFromTheme = function(isOn, disabled, theme) {
    var toggle = themeOrDefault(theme).toggle;
    return toggle[disabled ? "disabled" : "active"][isOn ? "on" : "off"].label.text;
};
var Container = styled.button.withConfig({
    componentId: "sc-72fb0ab-0"
})([
    "display:flex;flex-direction:",
    ";align-items:center;cursor:pointer;appearance:none;",
    ""
], function(props) {
    return props.$reverseDirection ? "row-reverse" : "row";
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
var ToggleWrapper = styled.div.withConfig({
    componentId: "sc-72fb0ab-1"
})([
    "position:relative;width:32px;border-radius:100px;height:18px;border:1px solid ",
    ";background-color:",
    ";"
], function(props) {
    return getBorderFromTheme(props.$isOn, props.$disabled, props.theme);
}, function(props) {
    return getContainerFillFromTheme(props.$isOn, props.$disabled, props.theme);
});
export var ToggleIndicator = styled.div.withConfig({
    componentId: "sc-72fb0ab-2"
})([
    "position:absolute;background-color:",
    ";transition:left 0.1s linear;top:calc(50% - 4px);width:8px;height:8px;border-radius:100px;left:",
    "px;"
], function(props) {
    return getIndicatorFillFromTheme(props.$isOn, props.$disabled, props.theme);
}, function(props) {
    return props.$isOn ? 18 : 4;
});
var StyledTypography = styled(Typography).withConfig({
    componentId: "sc-72fb0ab-3"
})([
    "&&&{color:",
    ";}"
], function(props) {
    return getColorFromTheme(props.$isOn, props.$disabled, props.theme);
});
